import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Wordmark } from '@/components/brand';

const points = [
  'The editor is built from the settings each plugin describes.',
  'Every change is reviewed before it reaches your server.',
  'Plugins validate and activate changes themselves.',
];

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle: string;
  children: ReactNode;
  footer: ReactNode;
}) {
  return (
    <div className="grid min-h-dvh bg-background lg:grid-cols-[minmax(0,1fr)_minmax(0,28rem)] xl:grid-cols-[minmax(0,1fr)_minmax(0,32rem)]">
      <div className="flex flex-col px-4 py-6 sm:px-10">
        <header>
          <Link to="/login" aria-label="ComfiConf" className="focus-ring inline-flex rounded-sm">
            <Wordmark />
          </Link>
        </header>
        <main className="flex flex-1 items-center justify-center py-10">
          <div className="w-full max-w-sm">
            <h1 className="text-xl font-semibold text-text">{title}</h1>
            <p className="mt-1 text-sm text-muted">{subtitle}</p>
            <div className="mt-6">{children}</div>
            <div className="mt-6 border-t border-border pt-4 text-sm text-muted">{footer}</div>
          </div>
        </main>
      </div>
      <aside
        aria-label="About ComfiConf"
        className="chrome hidden border-l border-chrome-border px-10 py-10 lg:flex lg:flex-col lg:justify-center"
      >
        <div className="max-w-sm">
          <p className="text-xs font-semibold uppercase tracking-wider text-chrome-muted">
            Plugin settings for Paper servers
          </p>
          <p className="mt-3 text-xl font-semibold text-chrome-text">
            Edit plugin settings in the browser. The plugins on your server decide what is applied.
          </p>
          <ul
            role="list"
            className="mt-6 divide-y divide-chrome-border border-y border-chrome-border text-sm text-chrome-muted"
          >
            {points.map((point) => (
              <li key={point} className="py-2.5">
                {point}
              </li>
            ))}
          </ul>
        </div>
      </aside>
    </div>
  );
}
